export default "__VITE_ASSET__CNb0u0o4__"